module.exports = __webpack_public_path__ + "static/media/US.cae1a345.svg";


//////////////////
// WEBPACK FOOTER
// ./src/US.svg
// module id = 89
// module chunks = 0